module.exports = __webpack_public_path__ + "static/media/report-commission-report.6562b0c5.png";